(function () {
  var AUTHOR_NAME = 'Olivia Hart';
  var AUTHOR_TITLE = 'Senior Manager, Marketing';
  var AUTHOR_LINE = AUTHOR_NAME + ', ' + AUTHOR_TITLE;
  var AUTHOR_BIO = 'Olivia Hart shares practical guidance on lab-grown diamonds, fine jewelry, and confident online buying for Luminary Gem customers.';
  var AUTHOR_IMAGE_FALLBACKS = [
    '/cdn/shop/files/Olivia_Hart.jpg',
    '/cdn/shop/files/Olivia%20Hart.jpg',
    '/cdn/shop/files/Olivia-Hart.jpg'
  ];

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function getArticlePublishedDate() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i += 1) {
      try {
        var data = JSON.parse(scripts[i].textContent || '{}');
        if (Array.isArray(data)) {
          for (var j = 0; j < data.length; j += 1) {
            if (data[j] && data[j].datePublished) return formatDate(data[j].datePublished);
          }
        } else if (data && data.datePublished) {
          return formatDate(data.datePublished);
        }
      } catch (e) {}
    }
    return '';
  }

  function setAuthorNameElements() {
    var selectors = [
      '.t4s-author-name',
      '.t4s-post-author .t4s-author-name',
      '.t4s-post-auth span'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var original = (el.textContent || '').trim();
        if (!original) return;
        if (/^by\s+/i.test(original)) {
          el.textContent = 'By ' + AUTHOR_LINE;
        } else {
          el.textContent = AUTHOR_LINE;
        }
      });
    });
  }

  function setArticleTitleMeta() {
    var articleDate = getArticlePublishedDate();
    document.querySelectorAll('.template-article .t4s-article-title ul').forEach(function (list) {
      var items = list.querySelectorAll('li');
      if (items[0]) {
        var authorSpan = items[0].querySelector('span, a') || items[0];
        authorSpan.textContent = AUTHOR_LINE;
      }
      if (articleDate && items[1]) {
        var dateSpan = items[1].querySelector('span, a') || items[1];
        dateSpan.textContent = articleDate;
      }
    });
  }

  function formatTimeElements() {
    document.querySelectorAll('.template-blog time[datetime], .template-article time[datetime]').forEach(function (time) {
      var formatted = formatDate(time.getAttribute('datetime'));
      if (formatted) time.textContent = formatted;
    });
  }

  function replaceLegacyAuthorText() {
    document.querySelectorAll('.t4s-article-title li span, .t4s-post-metas span, .t4s-post-info span').forEach(function (el) {
      if (!el.childElementCount && /Shaoxin|ShaoXin|Shaoxin Zhang|ShaoXin Zhang|Olivia Hart/.test(el.textContent || '')) {
        if (/^by\s+/i.test(el.textContent || '')) {
          el.textContent = 'By ' + AUTHOR_LINE;
        } else {
          el.textContent = AUTHOR_LINE;
        }
      }
    });
  }

  function createAuthorCard() {
    var card = document.createElement('section');
    card.className = 'lg-blog-author-card';
    card.setAttribute('data-lg-blog-author-card', '');

    var avatar = document.createElement('img');
    avatar.className = 'lg-blog-author-card__avatar';
    avatar.src = AUTHOR_IMAGE_FALLBACKS[0];
    avatar.alt = AUTHOR_NAME;
    avatar.loading = 'lazy';
    avatar.setAttribute('data-fallback-index', '0');
    avatar.onerror = function () {
      var currentIndex = parseInt(avatar.getAttribute('data-fallback-index') || '0', 10);
      var nextIndex = currentIndex + 1;
      if (nextIndex < AUTHOR_IMAGE_FALLBACKS.length) {
        avatar.setAttribute('data-fallback-index', String(nextIndex));
        avatar.src = AUTHOR_IMAGE_FALLBACKS[nextIndex];
      } else {
        avatar.style.display = 'none';
      }
    };

    var content = document.createElement('div');
    content.className = 'lg-blog-author-card__content';
    content.innerHTML = '<div class="lg-blog-author-card__label">About the Author</div>' +
      '<h3>' + AUTHOR_LINE + '</h3>' +
      '<p>' + AUTHOR_BIO + '</p>';

    card.appendChild(avatar);
    card.appendChild(content);
    return card;
  }

  function ensureAuthorCard() {
    if (!document.body.classList.contains('template-article')) return;
    if (document.querySelector('[data-lg-blog-author-card]')) return;

    var social = document.querySelector('.t4s-article-social-share');
    var content = document.querySelector('.t4s-article-content');
    var target = social || content;
    if (!target || !target.parentNode) return;

    target.insertAdjacentElement('afterend', createAuthorCard());
  }

  function run() {
    if (!document.body || (!document.body.classList.contains('template-article') && !document.body.classList.contains('template-blog'))) return;
    setAuthorNameElements();
    setArticleTitleMeta();
    formatTimeElements();
    replaceLegacyAuthorText();
    ensureAuthorCard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
